import VueElementLoading from 'vue-element-loading';
import moment from 'moment';
import Multiselect from 'vue-multiselect';
import apiUrl from '../../../../../constants';
import awsBucketName from '../../../../../constants';
import axios from 'axios';
import {SearchApi} from '../../../../../services/B2BModule/SearDataAPI';
import {GetAllHubData} from '../../../../../services/B2BModule/CommonFuntion';
import actionComponent from '../../../../B2B components/actionComponent'
import {update} from '../../../../../services/B2b/services/update';
import {imageList} from '../../../../../services/B2b/services/imageList';
import {fetchImage} from '../../../../../services/B2b/services/fetchImages';
import { custom_sort } from '../../../../../services/utility';

export default {
    name: 'EditOprationExecutive',
    components: {
        VueElementLoading,
        Multiselect,
        actionComponent

    },
    data() {
        return {
            awbnumber: '',
            token: '',
            show: false,
            alldata: {},
            submitDisable: true,
            token: '',
            imagesarr: [],
            images:[],

            attachment: null,
            displaytable: false,
            newhubs: '',
            Reason: '',
            fieldsAccessData: {},

        }
    },
    mounted() {
        var userToken = window.localStorage.getItem('accessuserToken');
        this.token = userToken.replace(/"/g, '');
        this.awbnumber = this.$route.query.awb;
        let statusdata=this.$route.query.status
        if(statusdata==4){statusdata="Pending with Finance (CN/COF)"}
        else{statusdata="Pending with Finance"}
        this.getData()
        this.getImages();
        this.fieldsAccessData = {
            userBucket: 'Finance',
            status: statusdata
            
        }
    },
    methods: {
        Backinvestigation() {
            this.$router.push({ path: '/FinanceExecutiveSearchPage' });

          },
          
          getData(){
            if (!this.awbnumber) return this.$alertify.error("Please Enter ShippingId ");

            let input = {
                shippingid:this.awbnumber
            }

            SearchApi(input, this.token)
            .then(result => {
                if (result.data.code == 200) {
                    this.alldata = result.data.data[0];
                    this.alldata.ShippingID = this.awbnumber;
                    this.alldata.Getallhubzone=GetAllHubData(this.alldata)
                    this.submitDisable = false;
                }
                else {
                    this.$alertify.error(result.data.message)
                }
            })
        },
        
        updateDetails(details,isRejected){
            let input = {
                shippingid : details.ShippingID,
                buckettypecode : details.buckettypecode,
                lastmodifiedby : window.localStorage.getItem('username'),
                verifieddescription : details.loggeddescription,
                description : details.loggeddescription,
                id : details.id,
                isRejected :isRejected
            }
            update(input,this.token).then(result => {
                if(result.data.status && result.data.statusCode == 200){
                    this.$alertify.success(result.data.message);
                    this.$router.push({ path: '/FinanceExecutiveSearchPage' });
                }else{
                    this.$alertify.error(result.message);
                }

            })
        },

        getImages(){
            //Fetching the available images with imageList()
            imageList(this.awbnumber, this.token).then(result=>{
                let list = result.data.data.Contents.sort(custom_sort);
                list = list.slice(0, 5);
                list.forEach(img => {
                    fetchImage(img.Key, this.token).then(result => {
                        let finalImage = result.data.ImageData.Body.data;
                        let buff = new Buffer.from(finalImage);
                        let base64data = buff.toString('base64');
                        this.images.push({attachment:'',url:'data:image/png;base64,' + base64data});
                    });
                });
            });
        },
    
        resetForm() {
            this.alldata = {};
            this.$validator.reset(); this.errors.clear();
        },
       
    }
}



// WEBPACK FOOTER //
// ./src/views/components/B2B/FinanceExecutive/EditFinanceExecutivepage/EditFinanceExecutivepage.component.js